export const AUTH_LOGOUT_REASON = {
  USER_LOGOUT: 'USER_LOGOUT',
  REMOTE_FORCE_LOGOUT: 'REMOTE_FORCE_LOGOUT',
  REMOTE_DELETE: 'REMOTE_DELETE',
  DEVICE_REVOKED: 'DEVICE_REVOKED',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
  DEVICE_KEY_MISMATCH: 'DEVICE_KEY_MISMATCH',
  DEBUG_RESET: 'DEBUG_RESET',
  SESSION_RECOVERY: 'SESSION_RECOVERY',
  AUTHORIZATION_RECOVERY: 'AUTHORIZATION_RECOVERY',
  SECURE_HANDOFF: 'SECURE_HANDOFF',
  DEBUG_REAUTHENTICATION: 'DEBUG_REAUTHENTICATION',
} as const;

export type AuthLogoutReason = (typeof AUTH_LOGOUT_REASON)[keyof typeof AUTH_LOGOUT_REASON];

const PAIRING_PRESERVING_REASONS = new Set<AuthLogoutReason>([
  AUTH_LOGOUT_REASON.SESSION_RECOVERY,
  AUTH_LOGOUT_REASON.AUTHORIZATION_RECOVERY,
  AUTH_LOGOUT_REASON.SECURE_HANDOFF,
  AUTH_LOGOUT_REASON.DEBUG_REAUTHENTICATION,
]);

export function shouldPreservePairingForLogout(reason: AuthLogoutReason): boolean {
  return PAIRING_PRESERVING_REASONS.has(reason);
}
